import { ModalDialog } from '../ChatWindow/Shared/ModalDialog';
import { useAppSelector } from '../../../../redux/app/hooks';
import { RootState } from '../../../../redux/app/store';

export const WebsocketErrorDialog: React.FC = () => {

    const { signalRConnectionError } = useAppSelector((state: RootState) => state.app);

    const refreshApp = () => {
        // Remove any trailing '#' as this causes issues with redirecting the user.
        const cleanUrl = window.location.href.replace(/#+$/, '');
        const url = new URL(cleanUrl);
        url.searchParams.set('reason', signalRConnectionError);
        window.location.href = url.toString();
    };

    return (
        <>
            <ModalDialog
                title="Connection Interrupted"
                open={signalRConnectionError !== ''}
                onClose={refreshApp}
                actionLabel="Refresh"
                onAction={refreshApp}
                showCloseButton={false}
            >
                <div>
                    <p>It looks like we've been disconnected from {import.meta.env.VITE_APP_NAME}.</p>
                    <p>Please refresh the page to get back on track with the latest updates.</p>
                </div>
            </ModalDialog>
        </>
    );
};
